import {UserState} from "../../state/user/userReducer";
import {getIsUserSuperadmin, getNodePermissionStr} from "../../utils/permissions";

export const DEFAULT_HOMEPAGE_NEWS_COUNT = 3;
export const DEFAULT_USE_HTML_EDITOR = false;
export const DEFAULT_NEWS_IMAGE = "config/images/default-node-background.jpg";

/* urls */
export const getNodeLatestNewsUrl = (nodeId: number, count?: number) =>
  `news/latest/${nodeId}` + (count ? `?n=${count}` : "");
export const getAllNewsUrl = () => `news/all`;
export const getDeleteNewsUrl = (id: number) => `news/${id}`;
export const getNewsUrl = (id: number) => `news/${id}`;
export const getSubmitNewsUrl = () => `news`;
export const getExportNewsUrl = (nodeId: number) => `news/export/${nodeId}`;

/* permissions */
export const canDisplayNewsManagerForm = (user: UserState, nodeId?: number) =>
  user &&
  user.isAuthenticated &&
  (getIsUserSuperadmin(user) ||
    (nodeId !== undefined && user.permissions.includes(getNodePermissionStr("ManageNews", nodeId))) ||
    (nodeId === undefined && !!user.permissions.find(p => p.startsWith("ManageNews_SingleNode"))));

/* news types */
export const NEWS_TYPE_DATA_UPDATES = "data-updates";
export const NEWS_TYPE_NEW_FUNCTIONALITY = "new-functionality";
export const NEWS_TYPE_NEW_NODE = "new-atlantes";
export const NEWS_TYPE_EVENT = "event";
export const NEWS_TYPE_OTHER = "other";

/* utils */
export const getFormattedDate = (dateStr: string, lang?: string) => {
  const format: Intl.DateTimeFormatOptions = {
    day: "numeric",
    month: "long",
    year: "numeric"
  };

  return new Date(dateStr).toLocaleDateString(`${lang === "it" ? "it-IT" : "en-GB"}`, format);
};
